const MESSAGE = {
    LINK_EXPIRED: "The password reset link is no longer valid as it has already been used.",
    ACTIVE_IN_OTHER_TAB: "Unable to perform your action. Sign out from all instances of this portal and try again.",

    // My Roleplay Empty card message
    EMPTY_MYROLEPLAY_ALL: "Select a new role play to participate.",
    EMPTY_MYROLEPLAY_SAVED: "No role play in draft.",
    EMPTY_MYROLEPLAY_SEARCH: "Sorry, no role play as per your search",
    EMPTY_ROLEPLAY_REVIEW: "No role play received for review.",
    EMPTY_ROLEPLAY_COMPLETE: "No role play review completed.",
    EMPTY_MYROLEPLAY_SUBMITTED: "No role play submitted for review.",
    EMPTY_MYROLEPLAY_REVIEWED: "No role play feedback pending from reviewer.",
    COACH_REQUIRED_MESSAGE: "You need a Coach to submit role play for review.",

    // PAYMENT
    PAYMENT_SUCCESFULL: "Payment Successful!",
    PAYMENT_FAILED: "Payment Failed!",
    PAYMENT_UPDATED_SUCCESSFULLY: "Payment Details Updated Successfully!",
    PAYMENT_UPDATED_FAILED: "Updating Payment Details Failed!",

    // REDIRECT
    REDIRECT_TO_HOME: "Redirecting to home ... ",
    REDIRECT_TO_SUBSCRIPTION: "Redirecting to subscription ... ",
    REDIRECT_TO_PAYMENT_SUMMARY: "Redirecting to payment summary ... ",
}

export default MESSAGE;